import Website from './Website';

export default Website;
